import {EventConstants} from 'constants/EventConstants';
import AppDispatcher from 'lib/Dispatcher';

import {Timer} from './TimerConstants';

const TimerActions = {
  updateTimer(timerId: string, options: Partial<Timer>) {
    AppDispatcher.dispatch({
      actionType: EventConstants.TIMER_UPDATE,
      timerId,
      options,
    });
  },

  removeTimer(timerId: string) {
    AppDispatcher.dispatch({
      actionType: EventConstants.TIMER_REMOVE,
      timerId,
    });
  },
};

export default TimerActions;
